// @flow

export const SET_DEBUG_MODE = 'debug/SET_DEBUG_MODE'
export const SET_DEBUG_UNLOCKED = 'debug/SET_DEBUG_UNLOCKED'

export const setDebugMode = (enabled: boolean) => ({
  type: SET_DEBUG_MODE,
  payload: {
    enabled,
  },
})

export const setDebugUnlocked = (unlocked: boolean) => ({
  type: SET_DEBUG_UNLOCKED,
  payload: {
    unlocked,
  },
})
